import { DatePicker } from 'antd';
import { PropTypes } from 'prop-types';
import moment from 'moment';

const AntdDatePicker = ({ style, size, ...props }) => {
  return (
    <DatePicker
      size={size === 'xLarge' ? 'large' : size}
      allowClear={false}
      showTime={{ format: 'HH:mm' }}
      format="DD/MM/YYYY HH:mm"
      showNow={false}
      style={{
        fontSize: '16px',
        color: ' #666666',
        background: '#f1f1f1',
        borderRadius: 0,
        width: '100%',
        ...(size === 'xLarge'
          ? {
              padding: '11.5px 20px',
            }
          : {}),
        ...style,
      }}
      cellRender={(current, { type, originNode }) => {
        if (type === 'year' || type === 'month') {
          return (
            <div className={`ant-picker-cell-inner ${type}`}>
              {type === 'year'
                ? current.year()
                : moment(current.toDate()).format('MMM')}
            </div>
          );
        }
        return originNode;
      }}
      needConfirm
      {...props}
    />
  );
};

AntdDatePicker.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  size: PropTypes.oneOf(['large', 'small', 'middle', 'xLarge']),
};

AntdDatePicker.defaultProps = {
  style: {},
  size: undefined,
};

export default AntdDatePicker;
